var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChooseVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.625 15.9688H5.90625V13.25C5.90625 13.1469 5.82188 13.0625 5.71875 13.0625H4.59375C4.49062 13.0625 4.40625 13.1469 4.40625 13.25V15.9688H1.6875C1.58437 15.9688 1.5 16.0531 1.5 16.1562V17.2812C1.5 17.3844 1.58437 17.4688 1.6875 17.4688H4.40625V20.1875C4.40625 20.2906 4.49062 20.375 4.59375 20.375H5.71875C5.82188 20.375 5.90625 20.2906 5.90625 20.1875V17.4688H8.625C8.72813 17.4688 8.8125 17.3844 8.8125 17.2812V16.1562C8.8125 16.0531 8.72813 15.9688 8.625 15.9688Z",
    fill: "#33B378"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0357 6.82983L17.4643 8.29545V5.27273C17.4643 4.57074 16.8877 4 16.1786 4H4.28571C3.57656 4 3 4.57074 3 5.27273V12.2727H4.44643V5.43182H16.0179V16.5682H10.7143V18H16.1786C16.8877 18 17.4643 17.4293 17.4643 16.7273V13.7045L20.0357 15.1702C20.4636 15.4148 21 15.1085 21 14.6213V7.38068C21 6.89148 20.4636 6.58523 20.0357 6.82983ZM19.5536 13.2472L17.4643 12.058V9.94403L19.5536 8.75284V13.2472Z",
    fill: "#33B378"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.4375C7.60313 7.4375 7.6875 7.35312 7.6875 7.25V6.125C7.6875 6.02187 7.60313 5.9375 7.5 5.9375H4.875C4.77187 5.9375 4.6875 6.02187 4.6875 6.125V7.25C4.6875 7.35312 4.77187 7.4375 4.875 7.4375H7.5Z",
    fill: "#33B378"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChooseVideo);
export default __webpack_public_path__ + "static/media/choose_video.3cc561ee.svg";
export { ForwardRef as ReactComponent };